import React, { useState, useEffect, useCallback } from 'react';
import api from '../../utils/api';
import { T, fmtDate } from '../theme';

export default function MeetingsTab({ accountId }) {
  const [meetings, setMeetings] = useState(null);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => {
    api.get(`/pm/brands/${accountId}/meetings`).then(r => setMeetings(r.data)).catch(() => setMeetings([]));
  }, [accountId]);
  useEffect(() => { load(); }, [load]);

  if (meetings === null) return <div style={{ color: T.muted, fontSize: 13 }}>Yükleniyor…</div>;
  if (!meetings.length) return (
    <div style={{ background: T.card, border: `1px dashed ${T.border2}`, borderRadius: 10, padding: 40, color: T.dim, fontSize: 14, textAlign: 'center' }}>
      Bu marka için toplantı yok. (Google Calendar senkronu ile otomatik gelir.)
    </div>
  );
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {meetings.map(m => (
        <MeetingCard key={m.id} m={m} open={openId === m.id}
          onToggle={() => setOpenId(openId === m.id ? null : m.id)} />
      ))}
    </div>
  );
}

function MeetingCard({ m, open, onToggle }) {
  const [draft, setDraft] = useState(m.summary || '');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const upcoming = new Date(m.meeting_date) >= new Date(new Date().toDateString());

  const save = async () => {
    setSaving(true);
    try { await api.patch(`/pm/meetings/${m.id}`, { summary: draft }); setSaved(true); setTimeout(() => setSaved(false), 1500); }
    catch (e) { alert('Kaydedilemedi: ' + (e.response?.data?.error || e.message)); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ background: T.card, border: `1px solid ${open ? T.blue : T.border}`, borderRadius: 10, overflow: 'hidden' }}>
      <div onClick={onToggle} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', cursor: 'pointer' }}>
        <div>
          <div style={{ color: T.text, fontSize: 14, fontWeight: 600 }}>{m.title || 'Toplantı'}</div>
          <div style={{ color: T.muted, fontSize: 12, marginTop: 2 }}>
            {fmtDate(m.meeting_date)} · {new Date(m.meeting_date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
            {upcoming && <span style={{ marginLeft: 8, color: T.blue }}>● yaklaşan</span>}
            {m.satisfaction && (
              <span title="Müşteri memnuniyeti (AI, 1-5)" style={{ marginLeft: 8, color: m.satisfaction >= 4 ? T.green : m.satisfaction <= 2 ? '#ef4444' : '#eab308' }}>
                {'★'.repeat(m.satisfaction)}{'☆'.repeat(5 - m.satisfaction)}
              </span>
            )}
            {m.task_count > 0 && <span style={{ marginLeft: 8 }}>· {m.task_count} görev</span>}
          </div>
        </div>
        <span style={{ color: T.dim, fontSize: 13 }}>{open ? '▲ özet' : (m.summary ? '📝 özet var ▾' : 'özet ekle ▾')}</span>
      </div>
      {open && (
        <div style={{ padding: '0 16px 16px', borderTop: `1px solid ${T.border}` }}>
          {m.attendees && <div style={{ color: T.dim, fontSize: 12, margin: '10px 0' }}>Katılımcılar: {m.attendees}</div>}
          {m.transcript_url && (
            <a href={m.transcript_url} target="_blank" rel="noreferrer" style={{ color: T.blue, fontSize: 12, display: 'inline-block', marginBottom: 8 }}>
              Fireflies dökümünü aç ↗
            </a>
          )}
          <div style={{ color: T.muted, fontSize: 11, textTransform: 'uppercase', letterSpacing: 1, margin: '4px 0 6px' }}>Toplantı Özeti</div>
          <textarea value={draft} onChange={e => setDraft(e.target.value)} rows={6}
            placeholder="Toplantı özeti / notları…"
            style={{ width: '100%', background: T.panel, border: `1px solid ${T.border2}`, borderRadius: 8, color: T.text, padding: 10, fontSize: 13, resize: 'vertical', outline: 'none', fontFamily: 'inherit', lineHeight: 1.5 }} />
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 8 }}>
            <button onClick={save} disabled={saving} style={{ padding: '8px 16px', background: T.blueDark, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>{saving ? '…' : 'Kaydet'}</button>
            {saved && <span style={{ color: T.green, fontSize: 12 }}>✓ Kaydedildi</span>}
          </div>
        </div>
      )}
    </div>
  );
}
